import { IClient } from "@interfaces/Core/Client/client";
import { ISelect } from "@interfaces/Shared/select";

const selectClientMapper = (client: IClient): ISelect => ({
  value: client?.uuid ?? "",
  label: client?.name ?? "No Data",
});

export default selectClientMapper;
